import {getCurrentPosition as getFallbackCurrentPosition} from "@irati/geolocation/src/services/fallbackPosition"
import {LatLng, Position} from "@irati/geolocation/src/types"
import {getNavigatorGeolocationOptions} from "./getNavigatorGeolocationOptions"

interface BrowserCoordinates {
  latitude: number,
  longitude: number
}

interface BrowserPosition {
  coords: BrowserCoordinates
}

const convertGeolocationPositionToLatLng = (position: BrowserPosition): LatLng => {
  const {
    coords: {latitude, longitude}
  } = position
  return {
    lat: latitude,
    lng: longitude
  }
}

export const getCurrentPosition = (options = {useFallback: true}): Promise<Position> => {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator)) {
      return reject("geolocation.services.browserPosition.getCurrentPosition.notSupported")
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latLng: convertGeolocationPositionToLatLng(position),
          isFallback: false
        }) 
      },
      (errorData) => {
        if (options.useFallback) {
          getFallbackCurrentPosition()
            .then((fallbackPosition) => resolve(fallbackPosition))
            .catch((fallbackError) => reject(fallbackError))
        } else {
          reject(errorData)
        }
      },
      getNavigatorGeolocationOptions()
    )
  })
}
